<template functional>
    <form-group :label="props.label" :help="props.help"
                v-bind:class="[data.staticClass, {'error' : props.v ? props.v.$error : null}]">
        <select class="form-select" :placeholder="props.placeholder"
                :value="props.value"
                :disabled="props.disabled"
                :readonly="props.readonly"
                :class="[props.inputClass]"
                v-on:change="($event) => {
                    listeners.input && listeners.input($event.target.value);
                    listeners.change && listeners.change($event.target.value);
                    if(props.v){
                       props.v.$touch();
                    }
                }"
        >
            <option disabled v-if="props.placeholder">{{ props.placeholder }}</option>
            <template v-for="(option, index) in props.options">
                <option :key="index" v-if="typeof option === 'object'" :value="option.value">{{ option.label }}</option>
                <option :key="index" v-else :value="option">{{ option }}</option>
            </template>
        </select>
    </form-group>
</template>

<script>
export default {
    name: 'FormSelect',
};
</script>
